'use client';
import React, { useState } from 'react';
import BannerSection from '../global/BannerSection';
import SimpleFormSection from '../global/SimpleFormSection';
import imageManagerOdonto from './imgs/BancoDeImagensOdonto';

export default function FormOdontoBanner() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
  });

  return (
    <section
      id="formulario"
      className="grid grid-cols-1 md:grid-cols-2 gap-4 items-center justify-center p-2"
      style={{
        backgroundImage: `url(${imageManagerOdonto.banners.BannerOdonto})`,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
      }}
    >
      <BannerSection
        chipText="Seu Sorriso Mais Saudável Com"
        titleText="Plano Odonto"
        descriptionText="Planos Empresariais De 2 a 29 Vidas, com o Melhor Custo Benefício"
        imageUrl={imageManagerOdonto.logos.SulAmericaLogo}
      />
      <SimpleFormSection formData={formData} setFormData={setFormData} />
    </section>
  );
}
